// /var/www/afra/192.testproject.work/maracar8/0.8.2/myapp/src/components/ToastNotification.js
import React, { useRef } from 'react';
import { Toast } from 'primereact/toast';

const ToastNotification = ({ showToast, toastMessage, toastVariant, setShowToast }) => {
  const toastRef = useRef(null);

  // แสดง Toast เมื่อ showToast เปลี่ยนเป็น true
  React.useEffect(() => {
    if (showToast) {
      toastRef.current.show({
        severity: toastVariant, // เช่น success, info, warn, error
        summary: toastVariant.charAt(0).toUpperCase() + toastVariant.slice(1), // แสดงชื่อประเภท
        detail: toastMessage,
        life: 3000, // ปิดอัตโนมัติใน 3 วินาที
        closable: true, // มีปุ่มปิด
      });

      // Reset state หลังจากแสดง
      setShowToast(false);
    }
  }, [showToast, toastMessage, toastVariant, setShowToast]);

  return (
    <div>
      <Toast ref={toastRef} position="top-right" />
    </div>
  );
};

export default ToastNotification;
